import { render, staticRenderFns } from "./RoleSessionPolicies.vue?vue&type=template&id=268d43aa&scoped=true"
import script from "./RoleSessionPolicies.vue?vue&type=script&lang=js"
export * from "./RoleSessionPolicies.vue?vue&type=script&lang=js"
import style0 from "./RoleSessionPolicies.vue?vue&type=style&index=0&id=268d43aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268d43aa",
  null
  
)

export default component.exports